import PartnerLoginTrackingReportComponent from "../Components/MHL_Reports/PartnerLoginTrackingReportComponent";

const PartnerLoginTrackingReportPage = () => {
    return (
        <div>
            <PartnerLoginTrackingReportComponent />
        </div>
    )
}

export default PartnerLoginTrackingReportPage;